import { AddOn } from './AddOn';

export class RemoveBranding extends AddOn {
  public get shortDescription(): string {
    return 'Make ‘Powered by eWebinar’ disappear from your registration pages, emails, and webinar room  – and use your own Favicon too!';
  }

  public get description(): string {
    return 'Make ‘Powered by eWebinar’ disappear from your registration pages, emails, and webinar room  – and use your own Favicon too!';
  }

  public get ctaText(): string | null {
    return `${this.name}`;
  }

  public get learnMoreHref(): string {
    return 'https://ewebinar.com/help/subscription-add-ons#remove-ewebinar-branding';
  }

  public image(): string | null {
    return require('$/images/logos/remove-branding.png').default;
  }
}
